import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { CreationState } from '../../../../graphql/generated/graphql';
import { SPACING_UNIT } from '../../../constant/spacing';
import LfToBr from '../../primitive/LfToBr';

interface Props {
  state: CreationState | null;
  proposed: boolean;
  className?: string;
}

const InspectionStatus = ({ state, proposed, className }: ClassAttributes<HTMLElement> & Props) => {
  let type: string;

  if (state === null || state === CreationState.InspectionModificationRequested) {
    type = proposed ? 'proposal_waiting' : 'waiting';
  } else if (state === CreationState.InInspection) {
    type = proposed ? 'proposal_in_inspection' : 'in_inspection';
  } else {
    type = proposed ? 'proposal_submitted' : 'submitted';
  }

  return (
    <div className={className}>
      <Heading>
        <FormattedMessage id={`show_creation_page.heading.inspection_status`} />
      </Heading>

      <Typography>
        <FormattedMessage id={`inspection_status.${type}`}>{(text: string) => <LfToBr text={text} />}</FormattedMessage>
      </Typography>
    </div>
  );
};

const Heading = styled(Typography)({ marginBottom: SPACING_UNIT });
Heading.defaultProps = { variant: 'subtitle1' };

export default InspectionStatus;
